
import { config } from '../core';
import matchMedia from '../helpers/matchMedia';
import { BodyScrollLock } from '../modules/BodyScrollLock';

export default class Menu {
  get CLASSES() {
    return {
      isMenuOpened: 'is-menu-opened',
      isAccordionOpened: 'is-opened',
    };
  }

  constructor() {
    this.$menu = document.querySelector('[data-menu]');
    if (!this.$menu) return;
    this.$main = document.querySelector('[data-elm="main"]');
    this.$trigger = document.querySelector('[data-menu-trigger]');
    this.$close = [...document.querySelectorAll('[data-menu-close]')];
    this.$accordionTrigger = [...document.querySelectorAll('[data-accordion-trigger]')];
    this.$accordion;
    this.$accordionContent;
    this.init();
  }

  init() {
    matchMedia(config.breakPoint.sp, (matches) => {
      if (matches) { 
        this.setup();
        this.onTriggerClicked();
        this.onCloseClicked();
        this.onAccordionClicked();
      }
    })
  }

  setup() {
    gsap.set(this.$menu, { xPercent: 100 })
  }

  show() {
    BodyScrollLock(true);
    this.$main.classList.add(this.CLASSES.isMenuOpened);
    gsap.to(this.$menu, {
      xPercent: 0,
      duration: 0.4,
      ease: 'power2.out',
    })
  }

  hide() {
    BodyScrollLock(false);
    this.$main.classList.remove(this.CLASSES.isMenuOpened);
    gsap.to(this.$menu, {
      xPercent: 100,
      duration: 0.4,
      ease: 'power2.out',
    })
  }

  onTriggerClicked() {
    this.$trigger.addEventListener('click', () => {
      this.$main.classList.contains(this.CLASSES.isMenuOpened) ? this.hide() : this.show();
    });
  }

  onCloseClicked() {
    this.$close.forEach((element) => {
      element.addEventListener('click', () => this.hide());
    });
  }

  onAccordionClicked() {
    this.$accordionTrigger.forEach(el => {
      el.addEventListener('click', () => {
        this.$accordion = el.closest('[data-accordion]');
        this.$accordionContent = this.$accordion.querySelector('[data-accordion-content]');
        this.accordionToggle(this.$accordion);
      });
    });
  }

  accordionToggle(target) {
    target.classList.contains(this.CLASSES.isAccordionOpened) ? this.accordionClosed(target) : this.accordionOpened(target);
  }

  accordionOpened(target) {
    target.classList.add(this.CLASSES.isAccordionOpened);
    gsap.to(this.$accordionContent, {
      height: 'auto',
      duration: 0.4,
      ease: 'power2.out"',
    })
  }

  accordionClosed(target) {
    target.classList.remove(this.CLASSES.isAccordionOpened);
    gsap.to(this.$accordionContent, {
      height: 0,
      duration: 0.4,
      ease: 'power2.out"',
    })
  }
}
